<template>
  <store-update v-if="meLoading" :btnText="'다음'" @emitResult="callback"></store-update>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  data: () => {
    return {
      meLoading: false,
    }
  },
  components: {
    StoreUpdate: () => import('@/components/store/StoreUpdate.vue'),
  },
  computed: {
    ...mapState('auth', ['me']),
    ...mapGetters('auth', ['referralCode', 'registerWooriCrowd']),
  },
  async created() {
    _meta({
      titles: ['상점정보입력'],
    })
    const r = await this.getMe()
    console.log('meLoad', r)
    this.meLoading = true
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    async callback(result) {
      if (result === true) {
        if (await redirectSignupManage()) {
          return
        }
        return await this.$router.replace(`/`)
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
